import React from 'react';
import { injectIntl } from 'react-intl';
import Select from 'react-select';
import emojiFlags from 'emoji-flags';

/**
 * ES6 stateless component
 * @param {object} props - React props object (options).
 */
const SelectWithFlags = (props) => {
  const { id, className, value, options, onChange, placeholder, disabled } =
    props;
  const formatOptionLabel = ({ code, alternate_label = undefined }) => {
    return (
      <div className='option-container d-flex flex-row w-100 justify-content-around'>
        <div className='d-flex flex-row col-6 px-0 justify-content-center'>
          {(code && emojiFlags.countryCode(code)?.emoji) || <></>}
        </div>

        <div className='d-flex flex-row col-6 px-0 justify-content-center'>
          <p className='flag-code my-0'>
            {(alternate_label && alternate_label) || code}
          </p>
        </div>
      </div>
    );
  };

  return (
    <Select
      id={id}
      data-testid={id}
      name='country_code'
      className={`select-with-flags ${className ? className : ''}`}
      classNamePrefix='select-with-flags'
      value={value}
      options={options}
      onChange={onChange}
      placeholder={placeholder || ''}
      formatOptionLabel={formatOptionLabel}
      isDisabled={disabled}
      isClearable={false}
      isSearchable={false}
      defaultMenuIsOpen={false}
    />
  );
};

export default injectIntl(SelectWithFlags);
